module.exports = __webpack_public_path__ + "static/google-maps-wien-8e7a29d424e3f3a95771715f9c9a99b6.png";